import React from 'react'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import HomeVideo from '../../assets/images/home-video.png'
import Grid from '@material-ui/core/Grid'
import {wizardMeta} from './constants'
import LinearProgress from '@material-ui/core/LinearProgress'
import WizardModal from './WizardModal'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    paddingBottom: '117px',
  },
}))

const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 10,
    width: '60%',
    marginLeft: '60px',
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#3473ff',
  },
}))(LinearProgress)

const SetupWizard = props => {
  const classes = useStyles()
  // console.log('meta', Object.keys(wizardMeta))
  const [url, setUrl] = React.useState('')
  const [openModal, setOpenModal] = React.useState(false)

  const openWizard = url => {
    setUrl(url)
    setOpenModal(true)
  }

  const handleBackdrop = () => {
    setOpenModal(false)
  }

  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Grid item xs={6}>
          <h4 className="wizard-header">
            Your personalized system is setting up. In the meantime, get a head start on learning
            our system!
          </h4>
        </Grid>
        <Grid item xs={6}>
          <BorderLinearProgress variant="determinate" value={props.progressStep} />
        </Grid>
      </Grid>
      <WizardModal openModal={openModal} url={url} handleBackdrop={handleBackdrop} />
      {Object.keys(wizardMeta).map(item => (
        <Grid container spacing={1}>
          <p className="wizard-title">{wizardMeta[item].title}</p>
          <Grid container item xs={12} spacing={3}>
            {wizardMeta[item].subItems.map(subItem => (
              <Grid item xs={4}>
                <p className="wizard-subtitle">{subItem.title}</p>
                <p className="wizard-info">Learn about the basics of Asset Panda!</p>
                <img
                  src={HomeVideo}
                  alt={HomeVideo}
                  style={{width: '100%'}}
                  onClick={() => openWizard(subItem.url)}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </div>
  )
}

export default SetupWizard
